export const formaLoginUrl =
  process.env.REACT_APP_FORMA_LOGIN_URL ||
  'https://signin.autodesk.com/?flowId=E7FVvpuqAs'
